module.exports = "/_next/static/images/e4e3c271ef2b5b2df057227ec8552909-image-right-lg.jpg";